<template>
  <div class="container">
    <span class="remain" @click="startCallBack">{{leftCount}}次机会</span>

    <LuckyWheel class="whell" ref="LuckyWheel" :default-style="{
      fontColor: '#43302F',
      fontSize: '12px'
    }" :blocks="[
      { padding: '0', background: '#FD9B2D' }
    ]" :prizes="prizes" :buttons="[
      { radius: '50px', background: '#FDFAFA' },
      { radius: '45px', background: '#FF4A3F' },
      { radius: '41px', background: '#FF4A3F', pointer: true },
      {
        radius: '35px', background: '#F6C256',
        imgs: [{ src: require('../../assets/images/activity/start-bt.png'), width: '100%', top: '-100%' }]
      }
    ]" @start="startCallBack" @end="endCallBack" />

    <div class="rule-box">
      <img src="../../assets/images/activity/rule-bg.png" alt="">
      <div v-if="logList.length">
        <div class="item" v-for="(item, index) in logList" :key="index">
          <span>{{item.chouJiangTime | filterTime}}</span> {{item.status === '0' ? '与奖品擦肩而过' : '抽中一张10元红旗代金券'}}
        </div>
      </div>
      <div v-else class="not-log">暂无抽奖记录</div>
    </div>

    <div class="lingjiang" @click="lingqu()">
      <img src="../../assets/images/activity/13.png" alt="">
      领奖
    </div>

    <div class="rule-box">
      <img src="../../assets/images/activity/rule-bg.png" alt="">
      <div class="rule-list">
        <p>1.每人有3次机会参与抽奖，中奖后输入手机号领取；</p>
        <p>2.今日奖项有红旗连锁提供的10元电子券，数量有限，先到先得；</p>
        <p>3.使用方式：</p>
        <p>在红旗连锁超市购买商品后可，点击短信电子码链接，系统会生成二维码，将该二维码出示给收银员即可。</p>
      </div>
    </div>

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <div class="block" @click.stop>
          <input v-model="phone" type="number" placeholder="请输入手机号">
          <div class="duihuan" @click="duihuan()">领取</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {Dialog} from 'vant'
  export default {
    data() {
      return {
        leftCount: '',
        status: '',
        received: '',
        prizes: [],
        logList: [], // 中奖记录
        phone: '',
        show: false
      }
    },
    mounted() {
      this.getPrizesList()
    },
    created() {
      this.prizeJudge()
      this.prizeRecord()
    },
    filters: {
      filterTime(val) {
        let date = new Date(val)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        let d = date.getDate()
        let h = date.getHours()
        let mm = date.getMinutes()
        let s = date.getSeconds()
        return `${y}-${m}-${d} ${h}:${mm}:${s}`
      }
    },
    methods: {
      getPrizesList() {
        this.prizes = []
        let data = [{
          title: '谢谢参与',
          desc: '很遗憾你未中奖'
        }, {
          title: '10元红旗代金券',
          desc: '恭喜你获得10元红旗代金券'
        }, {
          title: '谢谢参与',
          desc: '很遗憾你未中奖'
        }, {
          title: '10元红旗代金券',
          desc: '恭喜你获得10元红旗代金券'
        }, {
          title: '谢谢参与',
          desc: '很遗憾你未中奖'
        }, {
          title: '10元红旗代金券',
          desc: '恭喜你获得10元红旗代金券'
        }, {
          title: '谢谢参与',
          desc: '很遗憾你未中奖'
        }, {
          title: '10元红旗代金券',
          desc: '恭喜你获得10元红旗代金券'
        }]
        data.forEach((item, index) => {
          this.prizes.push({
            title: item.desc,
            background: index % 2 ? '#FEB446' : '#FEFEFC',
            fonts: [{
              text: item.title,
              top: '10%'
            }],
            imgs: [{
              src: index % 2 ? require('../../assets/images/activity/11(1).png') : require(
                '../../assets/images/activity/10(1).png'),
              width: '35%',
              top: '40%'
            }],
          })
        })
      },
      startCallBack() {
        if (this.leftCount > 0) {
          this.leftCount--
          this.$refs.LuckyWheel.play()
          this.prizeDraw()
        } else {
          this.$toast('暂无抽奖次数')
        }
      },
      endCallBack(prize) {
        Dialog.alert({
          title: '',
          message: prize.title,
        }).then(() => {
          
        })
      },
      prizeJudge() {
        this.$api.questionnaire.prizeJudge('', res => {
          this.leftCount = res.data.leftCount
          this.received = res.data.received
          this.status = res.data.status
        })
      },
      prizeDraw() {
        this.$api.questionnaire.prizeDraw('', res => {
          setTimeout(() => {
            this.$refs.LuckyWheel.stop(res.data - 1) // 中奖的索引
            setTimeout(() => {
              this.prizeRecord()
              this.prizeJudge()
            }, 1000)
          }, 3000)
        })
      },
      prizeRecord() {
        this.$api.questionnaire.prizeRecord('', res => {
          this.logList = res.data
        })
      },
      lingqu() {
        if (this.status === '1' && this.received === '0') {
          this.show = true
        } else {
          this.$toast('暂无奖品可以领取')
        }
      },
      duihuan() {
        this.$api.questionnaire.received({phone: this.phone}, res => {
          this.$toast('兑换成功')
          this.show = false
          this.phone = ''
          this.prizeJudge()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding-top: 176px;
    padding-bottom: 30px;
    min-height: 100vh;
    box-sizing: border-box;
    background: rgb(251, 71, 30) no-repeat;
    background-image: url('../../assets/images/activity/bg.png');
    background-size: contain;
    background-position: top;
    position: relative;

    .remain {
      position: absolute;
      left: 50%;
      top: 324px;
      transform: translate(-50%, 0);
      z-index: 999;
      color: #A6352E;
      font-size: 13px;
    }

    .whell {
      width: 290px;
      height: 290px;
      margin: 0 auto
    }

    .rule-box {
      position: relative;
      margin: 70px 20px 0;
      border: 8px solid #FFBE9A;
      background: #FFDFCD;
      border-radius: 3px;
      padding: 30px 14px 20px;

      img {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50px);
        width: 225px;
        height: 33px
      }

      .item {
        font-size: 12px;
        color: #3D3636;
        font-weight: bold;
        margin-bottom: 8px;

        span {
          color:#777777;
          margin-right: 16px;
        }
      }

      .not-log {
        text-align: center;
        font-size: 13px;
        color: #777777
      }

      .rule-list {
        p {
          font-size: 12px;
          line-height: 20px
        }
      }
    }

    .lingjiang {
      width: 134px;
      height: 40px;
      background: #fff;
      border-radius: 20px;
      margin: 30px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: #FB471E;
      font-weight: bold;

      img {
        margin-right: 6px;
        width: 23px;
        height: 23px
      }
    }

    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .block {
        width: 300px;
        background: #fff;
        border-radius: 10px;
        padding: 20px 0;

        input {
          width: 240px;
          height: 30px;
          font-size: 14px;
          display: block;
          margin: 0 auto;
          padding-left: 4px;
        }

        .duihuan {
          background: #EF5A4C;
          width: 260px;
          margin: 30px auto 0;
          height: 40px;
          line-height: 40px;
          color: #fff;
          text-align: center;
          border-radius: 8px;
          font-size: 16px
        }
      }
    }
  }
</style>
